const APP_REVIEW_SHOWN_KEY = 'gitfit-app-review-requested';

/** Check if we're running inside the Natively native app wrapper */
function isNativeApp(): boolean {
  return typeof window !== 'undefined' &&
    !!(window.NativelyInfo || window.NativelyHealth || (window as any).natively);
}

/** Request an App Store review via Natively SDK, only once per device */
export function maybeRequestAppReview() {
  try {
    if (!isNativeApp()) return;
    if (localStorage.getItem(APP_REVIEW_SHOWN_KEY)) return;
    if ((window as any).natively?.requestAppReview) {
      console.log('[AppReview] Requesting app review');
      (window as any).natively.requestAppReview();
      localStorage.setItem(APP_REVIEW_SHOWN_KEY, new Date().toISOString());
    }
  } catch (e) {
    console.warn('[AppReview] Failed to request app review:', e);
  }
}
